import { useEffect, useCallback, useRef } from 'react';
import WebApp from '@twa-dev/sdk';

export function useBackButton({ onClick, visible = false }) {
    const callbackRef = useRef(onClick);
    callbackRef.current = onClick;

    const stableHandler = useCallback(() => {
        callbackRef.current?.();
    }, []);

    useEffect(() => {
        const btn = WebApp.BackButton;

        if (!visible) {
            btn.hide();
            return () => { btn.offClick(stableHandler); };
        }

        btn.onClick(stableHandler);
        btn.show();

        return () => {
            btn.offClick(stableHandler);
            btn.hide();
        };
    }, [visible, stableHandler]);
}
